import axios from "axios";
import { ServiceRateCard } from "../../services/serviceRateCard.service";
import { accountConstants } from "../constants";
import { FETCH_ALL_LEDGER_FAILED, FETCH_ALL_LEDGER_PENDING, FETCH_ALL_LEDGER_SUCCESS, GET_ALL_LEDGER_CURRENCY, GET_ALL_LEDGER_PAYMENT_MODE_LIST, GET_ALL_LEDGER_STATUS_LIST, GET_ALL_LEDGER_TRANSACTION_MODE, GET_ALL_LEDGER_TRANSACTION_TYPE, GET_SELLER_LEDGER_TOTALS_SUCCESS, GET_SELLER_LEDGER_TOTALS_PENDING } from "../types";
import { apiUrl } from "../../constant";
import { formatNumberWithCommas } from "../../config/utils";
/* istanbul ignore next */
export const handleMenu = (data) => ({
    type: accountConstants.SHOW_ACCOUNTING_MENU,
    payload: data,
});

const fetchLedgerListSuccess = (response) => ({
    type: FETCH_ALL_LEDGER_SUCCESS,
    payload: response,
});
const fetchLedgerListFailed = () => ({
    type: FETCH_ALL_LEDGER_FAILED,
});
const fetchLedgerListPending = () => ({
    type: FETCH_ALL_LEDGER_PENDING
});
/* istanbul ignore next */
const getFormattedStatusName = (statusName) => {
    if (statusName === "Pending") {
        return `<span class="activeStatus uploads activeStatusInprogress">Pending</span>`;
    }
    if (statusName === "Completed") {
        return `<span class="activeStatus uploads activeStatusApproved">Completed</span>`;
    }
    return statusName;
};
/* istanbul ignore next */
const getFormattedBalance = (balance) => {
    let balanceClass;
    if (balance > 0) {
        balanceClass = 'credit balance';
    } else if (balance < 0) {
        balanceClass = 'debit balance';
    } else {
        balanceClass = 'balance zero';
    }
    return `<span class="${balanceClass}">$ ${formatNumberWithCommas(balance)}</span>`;
};
/* istanbul ignore next */
export const fetchLedgerListing = (data) => {
    return (dispatch) => {
        dispatch(fetchLedgerListPending());
        ServiceRateCard.GetAllLedgerService(data).then((result) => {
            let listUpdate = result.data.EntityList.map(item => {
                return {
                    ...item,
                    statusName: getFormattedStatusName(item.statusName),
                    credit: item.credit ? `<span class="credit">$ ${item.credit}</span>` : '',
                    debit: item.debit ? `<span class="debit">$ ${item.debit}</span>` : ''
                };
            });
            let ledgerData = {
                ledgerList: listUpdate || [],
                TotalRecords: result.data.TotalRecords
            }
            dispatch(fetchLedgerListSuccess(ledgerData));
        }).catch((error) => {
            dispatch(fetchLedgerListFailed());
        })
    };
};
/* istanbul ignore next */
export const getAllLedgerTransactionMode = () => {
    return (dispatch) => {
        ServiceRateCard.GetAllLedgerTransactionMode().then((result) => {
            dispatch({
                type: GET_ALL_LEDGER_TRANSACTION_MODE,
                payload: result.data.EntityList || []
            });
        }).catch((error) => {
            console.error("Error fetching ledger transaction modes:", error);
        });
    };
}
/* istanbul ignore next */
export const GetAllLedgerTransactionType = () => {
    return (dispatch) => {
        ServiceRateCard.GetAllLedgerTransactionType().then((result) => {
            dispatch({
                type: GET_ALL_LEDGER_TRANSACTION_TYPE,
                payload: result.data.EntityList || []
            });
        }).catch((error) => {
            console.error("Error fetching ledger transaction types:", error);
        });
    }
};
/* istanbul ignore next */
export const GetAllLedgerCurrency = () => {
    return (dispatch) => {
        ServiceRateCard.GetAllLedgerCurrencyService().then((result) => {
            dispatch({
                type: GET_ALL_LEDGER_CURRENCY,
                payload: result.data.EntityList || []
            });
        }).catch((error) => {
            console.error("Error fetching ledger currency:", error);
        });
    }
};
/* istanbul ignore next */
export const GetAllLedgerPaymentMode = () => {
    return (dispatch) => {
        ServiceRateCard.GetAllLedgerPaymentModeService().then((result) => {
            dispatch({
                type: GET_ALL_LEDGER_PAYMENT_MODE_LIST,
                payload: result.data.EntityList || []
            });
        }).catch((error) => {
            console.error("Error fetching ledger payment mode service:", error);
        });
    }
};
/* istanbul ignore next */
export const createLedger = (data) => {
    return axios.post(`${apiUrl}/api/Ledger/CreateLedgerEntry`, data);
};
/* istanbul ignore next */
export const updateLedger = (data) => {
    return axios.put(`${apiUrl}/api/Ledger/UpdateLedgerEntry`, data);
};
/* istanbul ignore next */
export const updateLedgerAttachments = (data) => {
    return axios.put(`${apiUrl}/api/Ledger/UpdateLedgerEntryAttachments`, data);
};
/* istanbul ignore next */
export const getAllLedgerStatus = () => {
    return (dispatch) => {
        ServiceRateCard.GetAllLedgerStatusService().then((result) => {
            dispatch({
                type: GET_ALL_LEDGER_STATUS_LIST,
                payload: result.data.EntityList || []
            });
        }).catch((error) => {
            console.error("Error fetching ledger Status", error);
        });
    }
};
/* istanbul ignore next */
export const getSellerLedgerTotals = (data) => {
    return (dispatch) => {
        dispatch({
            type: GET_SELLER_LEDGER_TOTALS_PENDING
        });
        axios.post(`${apiUrl}/api/Ledger/GetSellerLedgerTotals`, data).then((result) => {
            let tooltipHtml = "";
            let listUpdate = result.data.EntityList.map((item, index) => {
                if (item.totalCreditPending) {
                    tooltipHtml = `
                        <i class="fa fa-info-circle tooltip-wrapper" aria-hidden="true">
                        <span class='tooltip-content'>
                            <ul>
                            <li>Credit Completed: 
                                <div class="mt-1"><b>$ ${formatNumberWithCommas(item.totalCreditCompleted) || 0}</b></div>
                            </li>
                            <li>Credit Pending: 
                                <div class="mt-1"><b>$ ${formatNumberWithCommas(item.totalCreditPending) || 0}</b></div>
                            </li>
                            </ul>
                        </span>
                    </i>`;
                }
                const creditClass = item.totalCreditPending > 0 ? "pending" : "credit";
                return {
                    ...item,
                    totalCredit: item.totalCredit ? `<span class='${creditClass}'>
                         $ ${formatNumberWithCommas(item.totalCredit)}
                       </span>
                       ${tooltipHtml}`
                        : "",
                    totalDebit: item.totalDebit
                        ? `<span class='debit'>$ ${formatNumberWithCommas(item.totalDebit)}</span>`
                        : '',
                    balance: getFormattedBalance(item.balance),
                    listIndex: index + 1
                };
            }) || [];
            let data = {
                list: listUpdate,
                TotalRecords: result.data.TotalRecords
            };
            dispatch({
                type: GET_SELLER_LEDGER_TOTALS_SUCCESS,
                payload: data || []
            });
        }).catch((error) => {
            console.error("Error fetching ledger Status", error);
        });
    }
};
